<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container" :style="{'max-width': width, 'max-height': maxHeight + 'px', overflow: (overflows ? 'visible':'auto')}">
          <div class="modal-body">
            <slot name="body">
              default body
            </slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
export default {
  name: 'modal',
  props: ['width', 'overflows'],
  mounted () {
    this.maxHeight = window.innerHeight * 0.9
    window.addEventListener('resize', () => { this.maxHeight = window.innerHeight * 0.9 })
  },
  data () {
    return {
      maxHeight: 0
    }
  }
}
</script>

<style scoped lang="scss">
@import '../assets/scss/app.scss';
.modal-mask {
  text-align: center;
  position: fixed;
  z-index: 9997;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}

.modal-wrapper {
  width: 100vw;
  display: table-cell;
  vertical-align: middle;
  text-align: center!important;
}

.modal-container {
  @extend .card;
  background-color: white;
  max-width: 90vw;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
  max-height: 90vh;
  box-sizing: border-box;
  padding: 20px;
  overflow-y: auto;
}

@media (max-width: 768px) {
  .modal-container {
    width: 90vw;
    max-width: 90vw;
    padding: 15px;
  }

  .modal-mask {
    padding: 0;
  }
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>



// WEBPACK FOOTER //
// src/components/Modal.vue